<script setup>
import { computed, defineAsyncComponent } from 'vue'
import CheckSvg from '@svg/new-check.svg'
import { useNotificationsStore } from '@/Stores/notifications'
import AccountCreated from './Types/AccountCreated.vue'
import CommentReply from './Types/CommentReply.vue'
import DiscussionReply from './Types/DiscussionReply.vue'
import AdminCommentCreated from './Types/AdminCommentCreated.vue'
import DiscussionMention from './Types/DiscussionMention.vue'

const notificationsStore = useNotificationsStore()

const props = defineProps({
    notification: Object
})

const notificationComponents = {
    AccountCreated,
    CommentReply,
    DiscussionReply,
    AdminCommentCreated,
    DiscussionMention
}
</script>

<template>
    <div class="relative">
        <div>
            <component :is="notificationComponents[notification.type]" :notification="notification" />
        </div>
        <time :title="notification.created_at.datetime" :datetime="notification.created_at.datetime" class="text-[rgba(112,120,176,1)] text-[0.70rem] mt-1 block">
            {{ notification.created_at.human }}
        </time>

        <button
            class="p-2 absolute -bottom-3 -right-3 group"
            v-if="!notification.is_read"
            v-on:click="notificationsStore.markNotificationRead(notification.id)"
        >
            <CheckSvg class="size-5 group-hover:text-[rgba(132,156,241,1)]" />
        </button>
    </div>
</template>
